module.exports = __webpack_public_path__ + "static/img/tkl.101ffe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/tkl.png
// module id = fiX9
// module chunks = 1